import React from 'react';
import { MessageCircle, Zap, Target } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useTranslations } from '@/lib/translations';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_wonderchat-mobile/artifacts/9pn3gi8c_ChatGPT%20Image%207%20feb%202026%2C%2019_58_01.png";

export const HeroSection = ({ onOpenChat }) => {
    const t = useTranslations();
    
    return (
        <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden pt-14">
            {/* Background Effects */}
            <div className="absolute inset-0 gradient-dark" />
            <div className="absolute inset-0 noise-bg" />
            
            {/* Animated gradient orbs */}
            <div className="absolute top-1/4 -left-32 w-64 h-64 rounded-full bg-primary/10 blur-3xl animate-pulse-slow" />
            <div className="absolute bottom-1/4 -right-32 w-96 h-96 rounded-full bg-accent/10 blur-3xl animate-pulse-slow" style={{ animationDelay: '1s' }} />

            <div className="container mx-auto px-4 relative z-10">
                <div className="flex flex-col items-center text-center max-w-4xl mx-auto">
                    {/* Logo Animation */}
                    <div className="mb-8 animate-fade-in">
                        <div className="relative">
                            <div className="absolute inset-0 bg-primary/20 rounded-full blur-2xl animate-pulse-glow" />
                            <img 
                                src={LOGO_URL} 
                                alt="Logo" 
                                className="relative h-36 w-36 sm:h-44 sm:w-44 object-contain animate-float"
                            />
                        </div>
                    </div>

                    {/* Tagline */}
                    <p className="text-lg sm:text-xl text-foreground/90 mb-8 max-w-2xl animate-slide-up" style={{ animationDelay: '0.2s' }}>
                        {t.heroTagline}
                    </p>

                    {/* CTA Button - Only one button now */}
                    <div className="flex flex-col sm:flex-row gap-3 mb-8 w-full sm:w-auto animate-slide-up" style={{ animationDelay: '0.3s' }}>
                        <Button 
                            onClick={onOpenChat}
                            size="lg"
                            className="gradient-gold text-primary-foreground font-semibold text-base px-8 py-6 shadow-gold hover:opacity-90 transition-opacity w-full sm:w-auto"
                        >
                            <MessageCircle className="w-5 h-5 mr-2" />
                            {t.startChatting}
                        </Button>
                    </div>

                    {/* Feature Pills */}
                    <div className="flex flex-wrap justify-center gap-2 animate-slide-up" style={{ animationDelay: '0.4s' }}>
                        {[
                            { icon: Zap, text: t.instantAnswers },
                            { icon: Target, text: t.personalizedPlans },
                        ].map((feature, index) => (
                            <div 
                                key={feature.text}
                                className="flex items-center gap-2 px-3 py-1.5 rounded-full bg-secondary/50 border border-border/50 text-sm text-foreground/90"
                            >
                                <feature.icon className="w-4 h-4 text-primary" />
                                {feature.text}
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* Scroll Indicator */}
            <div className="absolute bottom-6 left-1/2 -translate-x-1/2 animate-bounce">
                <div className="w-5 h-8 rounded-full border-2 border-foreground/30 flex items-start justify-center p-1.5">
                    <div className="w-1 h-2 rounded-full bg-primary animate-pulse" />
                </div>
            </div>
        </section>
    );
};

export default HeroSection;
